module.exports = "<dl class=\"form-element\">\n    <dt>\n        <label>Kategoria</label>\n    </dt>\n    <dd>\n        <select\n            ng-class=\"CompanyConfigurationCategoriesCtrl.isFullWidth ? 'full-width' : ''\"\n            name=\"category\"\n            ng-model=\"CompanyConfigurationCategoriesCtrl.category\"\n            ng-options=\"item.id as item.name for item in CompanyConfigurationCategoriesCtrl.categories\"\n        >\n            <option value=\"\">Kategoria</option>\n        </select>\n    </dd>\n</dl>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/issue_forms/fragments/issue-category/issue-category.html
// module id = 674
// module chunks = 0